// extracted by mini-css-extract-plugin
export default {"vanier":"Vanier_vanier__GSXq6","imgLogo":"Vanier_imgLogo__it0d7"};